import { Col, Container, Row } from "reactstrap"
import { useGetVisitorListQuery } from "../../features/CallApi"
import { useParams } from "react-router-dom"
import { HttpTransportType, HubConnectionBuilder } from "@microsoft/signalr";
import useToken from "../useToken"
import { useEffect, useState } from "react";



export const QueueScreenOutLogo = () => {
    const [connection, setConnection] = useState(null);
    const { id } = useParams()
    const { data, refetch } = useGetVisitorListQuery({ id })
    const { token } = useToken();
    const snd = new Audio('/Content/Alarm.mp3');
    const playSound = () => {
        snd.play();
    }

    useEffect(() => {
        refetch()
        const newConnection = new HubConnectionBuilder()
            .withUrl("/visitorlisthub", {
                headers: {
                    Authorization: "Bearer " + token,
                },
                transport: HttpTransportType.LongPolling
            })
            .withAutomaticReconnect()
            .build()
        setConnection(newConnection)
    }, [])

    useEffect(() => {
        if (connection) {
            connection.on("ReceiveMessage", (sessionId, status) => {
                if (sessionId == id) {
                    refetch();
                    if(status === 3){
                        playSound()
                    }
                }
            });
            connection.start().then(() => {
                console.log("Connected!");
            });
            return () => connection.stop();
        }

    }, [connection]);



    return (
        <Container fluid style={{overflowX: "hidden"}}>
            <Row>
                {/* <Col xs="6" className="p-0 text-center bg-dark">
                    <video className="img-fluid" style={{ height: "100vh", width: "auto", objectFit: "cover" }} autoPlay playsInline loop muted><source src="/Content/Logo_Assol2022.mp4" type="video/mp4;" codecs="avc1.42e01e, mp4a.40.2" /></video>
                </Col> */}
                <Col>
                    <div className="border-bottom text-center">
                        <h1 style={{ height: "5vh" }}>Приглашаем пройти в зал</h1>
                    </div>
                    {data && data.visitorsLists.length > 0 ?
                        <div className="d-v-flex">
                            {data.visitorsLists.filter(item => item.visitorStatus == 3).map(visitor =>
                                <span key={visitor.id} className="badge-light rounded h1 m-1 border p-1">{visitor.numberOfList}</span>
                            )}
                        </div>
                        : ""
                    }
                </Col>
            </Row>
        </Container>
    )
}